<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search ref="buttonSearch" placeholder="搜索名稱" @search="searchEvent" :showGj="false">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" @click="openModel(false)" type="primary" size="mini" v-auth="'addBg'">添加页面</el-button>
					<!-- <el-button type="danger" v-auth="'delBg'" @click="deleteAll" size="mini">批量删除</el-button>
-->
				</template>

				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="管理员名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索管理员名稱"></el-input>
						</el-form-item>
						<el-form-item label="登錄賬號" class="mb-0">
							<el-input size="small" v-model="from.username" placeholder="搜索登錄賬號"></el-input>
						</el-form-item>
						<el-form-item label="登錄狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="啟用" :value="1"></el-option>
								<el-option label="禁用" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="所属角色" class="mb-0">
							<el-select v-model="from.rule_id" size="small" filterable placeholder="請選擇">
								<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">

				</el-table-column>
				<el-table-column align="center" type="index" label="排序" width="50">
				</el-table-column>
				<el-table-column align="center" prop="name" label="页面图標">
					<template slot-scope="scope">
						<i :class="scope.row.icon"></i>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="level" label="等級">
				</el-table-column>
				<el-table-column align="center" prop="name" label="名稱">
				</el-table-column>
				<el-table-column align="center" prop="rule_name" label="按钮规则">
				</el-table-column>
				<el-table-column align="center" prop="pathname" label="地址">
				</el-table-column>
				<el-table-column align="center" prop="api" label="API">
				</el-table-column>


				<el-table-column align="center" prop="name" label="是否跳转">
					<template slot-scope="scope">
						<span v-if="scope.row.is_tiao==1" class="text-success">是</span>
						<span v-else class="text-danger">否</span>
					</template>

				</el-table-column>

				<el-table-column align="center" prop="name" label="是否加入规则">
					<template slot-scope="scope">
						<span v-if="scope.row.is_rule==1" class="text-success">是</span>
						<span v-else class="text-danger">否</span>
					</template>
				</el-table-column>



				<el-table-column align="center" prop="create_time" label="創建時間">
				</el-table-column>
				<!-- <el-table-column prop="id" align="center" width="200" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button  v-auth="'editBg'" size="mini" plain type="primary" @click="openModel(scope)">编辑</el-button>
							<el-button  v-auth="'delBg'" @click="deleteItem(scope.row)" size="mini" plain type="danger">删除</el-button>
						</el-button-group>
					</template>
				</el-table-column> -->
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog  :close-on-click-modal="false" :title="editIndex > -1 ? '修改'+model_title : '添加'+model_title" :visible.sync="createModel" top="5vh">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" label-width="100px">

				<el-form-item label="所属上級" prop="title">
					<el-select size="small" v-model="form.parent" filterable placeholder="請選擇">
					    <el-option
					      v-for="item in options"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</el-form-item>
				

				<el-form-item label="名稱" prop="title">
					<el-input v-model="form.name" placeholder="名稱" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				<el-form-item label="图標" prop="title">
					<el-input v-model="form.icon" placeholder="图標" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				<el-form-item label="地址" prop="title">
					<el-input v-model="form.path" placeholder="地址:eg:set_admin" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				
				<el-form-item label="目录" prop="title">
					<el-input v-model="form.dir" placeholder="目录:访问目录:user" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				
				<el-form-item label="文件" prop="title">
					<el-input v-model="form.file" placeholder="文件:访问文件:Admin" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>

				<el-form-item label="是否跳转" prop="title">
					<el-radio-group v-model="form.is_tiao" size="small">
					      <el-radio :label="1" border>跳转</el-radio>
					      <el-radio :label="0" border disabled>不跳转</el-radio>
					    </el-radio-group>
				</el-form-item>
				
				<el-form-item label="是否加入规则" prop="title">
					<el-radio-group v-model="form.is_rule" size="small">
					      <el-radio :label="1" border>是</el-radio>
					      <el-radio :label="0" border disabled>否</el-radio>
					    </el-radio-group>
				</el-form-item>

			

				<el-form-item label="增加" prop="title">
					<el-input v-model="form.add" placeholder="增加:增加规则" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				
				<el-form-item label="删除" prop="title">
					<el-input v-model="form.del" placeholder="删除" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				<el-form-item label="修改" prop="title">
					<el-input v-model="form.edit" placeholder="修改" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				
				<el-form-item label="修改狀態" prop="title">
					<el-input v-model="form.edit_status" placeholder="修改狀態" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				
				
				

				<el-form-item label="
						 排序" prop="sort">
							<el-input-number v-model="form.sort" size="mini" label="排序"></el-input-number>

				</el-form-item>
			

			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					username: '',
					status: -1,
					rule_id: '',
					time: [],
				},
				model_title: '页面',
				auth_val: 'Music',
				preUrl: "user/pageList", //列表地址
				delAllUrl: "room/delBgAll", //批量删除地址
				delUrl: "room/delBg", //删除單条地址
				addUrl: "user/addPage", //添加/修改地址
				editStatusUrl: "room/editStatusBg", //修改狀態地址

				tableData: [],
				form: {
					parent:0,
					parth: '',
					name: "",
					path: '',
					dir: '',
					file: '',
					is_tiao: 1,
					is_rule: 1,
					add:'',
					del:'',
					edit:'',
					edit_status:'',
					sort:0
				},
				rules: {


				},
				options:[],
				rule_list: [],
				check_img_list: []
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList();
		},
		methods: {
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						parent:'',
						parth: '',
						name: "",
						path: '',
						dir: '',
						file: '',
						is_tiao: 1,
						is_rule: 1,
						add:'',
						del:'',
						edit:'',
						edit_status:'',
						sort:0
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						headUrl: e.row.url,
						headId: 0,
						title: e.row.title,
						is_show: e.row.is_show,
						sort: e.row.sort
					}

					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},

			//公共列表
			commonList() {
				this.layout.loading = true;
				this.axios.post('/admin/user/oneList', {
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					console.log(all.data.list)
					this.options = list
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item => {
					return item.url
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username: '',
					status: -1,
					rule_id: '',
					time: [],
					end_time: ''
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>


<style>
</style>
